import { render, staticRenderFns } from "./StatisticTaxRevenues.vue?vue&type=template&id=0132f99a&scoped=true&"
import script from "./StatisticTaxRevenues.vue?vue&type=script&lang=js&"
export * from "./StatisticTaxRevenues.vue?vue&type=script&lang=js&"
import style0 from "./StatisticTaxRevenues.vue?vue&type=style&index=0&id=0132f99a&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0132f99a",
  null
  
)

export default component.exports